import { Box, Skeleton } from "@mui/material";
import React from "react";

const ProductSkeletonLarge = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {/* Header Skeleton */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          padding: "8px 16px 0px 16px",
        }}
      >
        <Skeleton
          variant="rectangular"
          width={120}
          height={45}
          sx={{ borderRadius: "10px" }}
        />
      </Box>


      {/* Main Content Skeleton */}
      <Box
        sx={{
          maxWidth: "1225px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          paddingTop: "20px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
            gap: 5,
          }}
        >
          {/* Left Column Image Skeleton */}
          <Box sx={{ maxWidth: "330px" }}>
            <Skeleton variant="rectangular" width="30vh" height="30vh" />
          </Box>

          {/* Right Column Skeletons */}
          <Box
            sx={{
              width: "70%",
            }}
          >
            <Box mt={1.0} mb={0.9} sx={{ width: "80%" }}>
              <Skeleton
                variant="rectangular"
                height="24px"
                sx={{ borderRadius: "16px" }}
              />
            </Box>
            <Box mt={1.3} mb={3} sx={{ width: "100%" }}>
              <Skeleton
                variant="rectangular"
                height="74px"
                sx={{ borderRadius: "5px" }}
              />
            </Box>
            <Box sx={{ width: "42%" }}>
              <Skeleton
                variant="rectangular"
                height="25px"
                sx={{ borderRadius: "5px" }}
              />
            </Box>
            <Box sx={{ width: "39%" }} mt={3.0}>
              <Skeleton
                variant="rectangular"
                height="55px"
                sx={{ borderRadius: "30px" }}
              />
            </Box>
            <Box sx={{ width: "18%" }} mt={2}>
              <Skeleton
                variant="rectangular"
                height="32px"
                sx={{ borderRadius: "5px" }}
              />
            </Box>
            <Box sx={{ width: "98%" }} mt={2}>
              <Skeleton
                variant="rectangular"
                height="5.5vh"
                sx={{ borderRadius: "5px" }}
              />
            </Box>
            <Box sx={{ width: "25%" }} mt={3} mb={3}>
              <Skeleton
                variant="rectangular"
                height="3vh"
                sx={{ borderRadius: "5px" }}
              />
            </Box>
            <Box sx={{ width: "100%" }} mt={2}>
              <Skeleton
                variant="rectangular"
                height="522px"
                sx={{ borderRadius: "5px" }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box> 
  );
};

export default ProductSkeletonLarge;
